module.exports = __webpack_public_path__ + "static/media/calendar_icon_selected.2c173677.svg";